import React from "react";
import styled from "styled-components";
import { getFlexCenter } from "../../../common/styles";
import EditEmailForm from "../../../common/components/EditEmailForm/EditEmailForm";
import Typography from "../../../common/components/Typography/Typography";
import { useTranslation } from "react-i18next";

const Root = styled.div`
  margin: 0 auto;
  width: auto;
  display: flex;
  ${getFlexCenter};
  padding: 64px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

const Wrapper = styled.div`
  max-width: 640px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

const Header = styled.div``;

const Description = styled.div`
  margin-top: 64px;
  margin-bottom: 56px;
`;

const AddEmail = () => {
  const { t } = useTranslation();
  return (
    <Root>
      <Wrapper>
        <Header>
          <Typography heading weight="500" fontFamily="Poppins" size="lg">
            {t("connect-email")}
          </Typography>
          <Description>
            <Typography secondary>{t("upload-track-email-info")}</Typography>
          </Description>
        </Header>
        <EditEmailForm />
      </Wrapper>
    </Root>
  );
};

export default AddEmail;
